export default "__VITE_ASSET__CPi5DZbg__"